export default [
  'arrow-right',
  'check',
  'filters',
  'alert',
  'eye',
  'eye-stroked',
  'arrow-left',
  'calendar',
  'minus',
  'cross',
  'full-arrow-up',
  'close',
  'plus',
  'user',
  'youtube',
  'instagram',
  'twitter',
  'facebook',
  'tiktok',
  'wechat',
  'weibo',
  'linkedin',
  'accessibility',
  'pen',
  'plus-thin',
  'arrow-down',
  'alert',
  'outside-link'
];
